import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type { RespiAllerPrickTestMeasurementsFinalCustomControlData } from './respiAllerPrickTestMeasurementsSchemaV1';

export type RespiAllerPrickTestMeasurementsReadLabelV1 = 'Huidpriktest';

export type RespiAllerPrickTestMeasurementsReadDataV1 = RespiAllerPrickTestMeasurementsFinalCustomControlData;

export type RespiAllerPrickTestMeasurementsReadKeyV1 = keyof RespiAllerPrickTestMeasurementsReadDataV1;

export const respiAllerPrickTestMeasurementsReadSectionsV1: TypedReadSchema<
    RespiAllerPrickTestMeasurementsReadKeyV1,
    RespiAllerPrickTestMeasurementsReadLabelV1
>[] = [
    {
        items: [{ key: 'explanation', label: 'Huidpriktest' }],
    },
];
